import { useMasterEntry } from '../../common/useMasterEntry';
import { relationApi } from '../api/relationApi';

export const useRelationEntryScreen = (id) => {
  return useMasterEntry({
    entityName: 'Relation',
    apiClient: relationApi,
    initialForm: {
      name: '',
    },
    listPath: '/masters/relation/list'
  });
};
